enum LocalizeMode {
	None = 0,
	SingleCulture = 1,
	AllCultures = 2,
}

export default LocalizeMode;
